<template>
<div>
    <div>
        <button :class="{'btn': true, 'active': isSeven}" @click="isSeven = true">最近7天</button>
        <button :class="{'btn': true, 'active': !isSeven}"  @click="isSeven = false">最近30天</button>
    </div>
    <canvas id="container"></canvas>
    <div>
        <button :class="{'btn': true, 'active': isPv}"  @click="isPv = true">PV</button>
        <button :class="{'btn': true, 'active': !isPv}"  @click="isPv = false">UV</button>
    </div>
</div>
</template>
<script>
import {
    getPvCount,
    getUvCount
} from '@/api/statistics'
import F2 from '@antv/f2';
export default {
    data() {
        return {
            chart: null,
            isSeven: true,
            isPv: true,
            pvData: [],
            uvData: [],
        }
    },
    watch: {
        isPv() {
            this.changeData()
        },
        isSeven() {
            this.changeData()
        }
    },
    created() {
        this.getTime();
        this.fetchPVCount();
        this.fetchUVCount();

    },
    methods: {
        // 获取时间
        getTime() {
            let startTime = new Date();
            let endTime = startTime.getTime() - 30 * 24 * 60 * 60 * 1000;
            endTime = new Date(endTime);
            let startMonth = startTime.getMonth() < 9 ? '0' + (startTime.getMonth() + 1) : startTime.getMonth() + 1;
            let startDate = startTime.getDate() < 10 ? '0' + startTime.getDate() : startTime.getDate();
            let startHours = startTime.getHours() < 10 ? '0' + startTime.getHours() : startTime.getHours();
            let startMinutes = startTime.getMinutes() < 10 ? '0' + startTime.getMinutes() : startTime.getMinutes();
            let startSeconds = startTime.getSeconds() < 10 ? '0' + startTime.getSeconds() : startTime.getSeconds();
            let endMonth = endTime.getMonth() < 9 ? '0' + (endTime.getMonth() + 1) : endTime.getMonth() + 1;
            let endDate = endTime.getDate() < 10 ? '0' + endTime.getDate() : endTime.getDate();
            let endHours = endTime.getHours() < 10 ? '0' + endTime.getHours() : endTime.getHours();
            let endMinutes = endTime.getMinutes() < 10 ? '0' + endTime.getMinutes() : endTime.getMinutes();
            let endSeconds = endTime.getSeconds() < 10 ? '0' + endTime.getSeconds() : endTime.getSeconds();
            this.endTime = `${endTime.getFullYear()}-${endMonth}-${endDate}  ${endHours}:${endMinutes}:${endSeconds}`;
            this.startTime = `${startTime.getFullYear()}-${startMonth}-${startDate}  ${startHours}:${startMinutes}:${startSeconds}`;
        },
        // 获取pv数量
        fetchPVCount() {
            let data = {
                startTime: this.endTime,
                endTime: this.startTime
            }
            getPvCount(data).then(({
                data
            }) => {
                if (data.code === 200) {
                    this.pvData = data.data.result;
                    this.$nextTick(() => {
                        this.drawLine();
                    })
                }
            }).finally(data => {

            })
        },
        // 获取uv数量
        fetchUVCount() {
            let data = {
                startTime: this.endTime,
                endTime: this.startTime
            }
            getUvCount(data).then(({
                data
            }) => {
                if (data.code === 200) {
                    this.uvData = data.data.result;
                    if (!this.chart && !this.ispv) {
                        this.$nextTick(() => {
                            this.drawLine();
                        })
                    }
                }
            }).finally(data => {

            })
        },
        drawLine() {
            let data = [{
                time: 'Jan.',
                tem: 1000
            }, {
                time: 'Feb.',
                tem: 2200
            }];
            data = this.isPv ? this.pvData : this.uvData;
            data = this.isSeven ? data.slice(-7) : data.slice();
            let maxCount = 0;
            let maxPosition = 0;
            data.forEach((item, index) => {
                item.time = item.viewTime;
                item.tem = item.count;
                if (item.count > maxCount) {
                    maxCount = item.count;
                    maxPosition = index;
                }
            })
            const chart = new F2.Chart({
                id: 'container',
                pixelRatio: window.devicePixelRatio
            });
            chart.source(data);
            // chart.tooltip({
            //   showCrosshairs: true
            // });

            chart.scale({
                time: {
                    range: [0, 1]
                },
                tem: {
                    tickCount: 5,
                    min: 0
                }
            });
            chart.axis('time', {
                label: function label(text, index, total) {
                    const textCfg = {
                        textAlign: 'right',
                        textBaseline: 'middle',
                        rotate: -Math.PI / 3
                    };
                    // if (index === 0) {
                    //     // textCfg.textAlign = 'left';
                    // } else if (index === total - 1) {
                    //     textCfg.textAlign = 'right';
                    // }
                    return textCfg;
                }
            });

            // chart.tooltip({
            //     showCrosshairs: true,
            //     onShow: function onShow(ev) {
            //         const items = ev.items;
            //         items[0].name = items[0].title;
            //     }
            // });
            chart.tooltip({
                showCrosshairs: true,
                custom: true,
                showXTip: true,
                showYTip: true,
                snap: true,
                crosshairsType: 'xy',
                crosshairsStyle: {
                    lineDash: [2]
                }
            });
            chart.guide().tag({
                position: [maxPosition, maxCount],
                content: maxCount,
                offsetY: -5,
                direct: 'tl'
            });
            chart.area().position('time*tem');
            chart.line().position('time*tem');

            // chart.point().position('time*tem').color('tem', value => {
            //     if (value === max) {
            //         return '#5185df';
            //     }
            //     return 'transparent';
            // });

            chart.render();
            this.chart = chart;
        },
        changeData() {
            if (!this.isPv && !this.uvData.length) {
                this.fetchUVCount();
                return;
            }
            let data = this.isPv ? this.pvData : this.uvData;
            data = this.isSeven ? data.slice(-7) : data.slice();
            let maxCount = 0;
            let maxPosition = 0;
            data.forEach((item, index) => {
                item.time = item.viewTime;
                item.tem = item.count;
                if (item.count > maxCount) {
                    maxCount = item.count;
                    maxPosition = index;
                }
            })

            this.chart.guide().clear();
            this.chart.guide().tag({
                position: [maxPosition, maxCount],
                content: maxCount,
                offsetY: -5,
                direct: 'tl'
            });
            this.chart.changeData(data);
        }
    }
}
</script>

<style lang="scss" scoped>
#container{
  height: 250px;
  width: 100%;
}
.btn{
  outline: none;
  border: 1px solid #ebedf0;
  background: transparent;
  line-height: 28px;
  width: 80px;
  margin-right: 10px;
  color: #323233;
  font-size: 12px;
  border-radius: 3px;
  &.active{
    color: #fff;
    background-color: #1989fa;
    border: 0.02667rem solid #1989fa;
  }
}
</style>
